
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ensqr",
      function () {
        return require("private-next-pages/ensqr.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ensqr"])
      });
    }
  